import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { JeeSession1Service } from '../jee-session1.service';
import { ColDef } from 'ag-grid-enterprise';
import { NgxSpinnerService } from 'ngx-spinner';
import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';
import { fontFamily } from 'html2canvas/dist/types/css/property-descriptors/font-family';
import { color } from 'highcharts';
import { textAlign } from 'html2canvas/dist/types/css/property-descriptors/text-align';
import { left } from '@popperjs/core';
import { MatDialog } from '@angular/material/dialog';
import { JeeMainsNotAppliedComponent } from '../jee-mains-not-applied/jee-mains-not-applied.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { align } from '@progress/kendo-drawing';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-jee-mains-session1-hlt-entry',
  templateUrl: './jee-mains-session1-hlt-entry.component.html',
  styleUrls: ['./jee-mains-session1-hlt-entry.component.scss']
})
export class JeeMainsSession1HltEntryComponent implements OnInit {
  name = 'angular';
  jeemainssession: any;


  columnDefs: ColDef[] = [
    {
      headerName: 'Edit',
      field: 'edit',
      cellRenderer: (params: any) => {
        return `<a style="color:#007BFF; font-weight:bold; cursor:pointer;">Edit</a>`;
      },
      onCellClicked: (params: any) => {
        if (params.data?.admNo) {
          this.onEditClick(params.data.admNo); // directly call component method
        }
      },
      cellStyle: { textAlign: 'center' },
      width: 100
    },



    { headerName: 'AddmissionNo', field: 'admNo', cellStyle: { textAlign: 'left' }, },
    { headerName: 'StudentName', field: 'studentName', cellStyle: { textAlign: 'left' }, },
    { headerName: 'PrentName', field: 'prentName', cellStyle: { textAlign: 'left' }, },
    { headerName: 'className', field: 'className', cellStyle: { textAlign: 'left' }, },
    { headerName: 'JeeMainsAppNo', field: 'jeeMainsAppNo' },
    { headerName: 'JeeMAinsHtNo', field: 'jeeMAinsHtNo' },
    { headerName: 'VitHtNo', field: 'VitHtNo' },
    { headerName: 'PasswordStatus', field: 'passwordStatus' }

  ];
 



  onEditClick(admNo: string): void {
    this.searchCriteria = admNo;
    this.getStudentDetails(this.searchCriteria);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);
  }



  columnDefsEntry: ColDef[] = [
    {
      headerName: 'Program',
      field: 'program',
      cellStyle: { textAlign: 'left' },
    },

    { headerName: 'Total', field: 'total' },
    { headerName: 'JeeMainsApplied', field: 'jeeMainsApplied' },
    {
      headerName: 'JeeMainsNotApplied', field: 'jeeMainsNotApplied',
    },
    {
      headerName: 'JeeMainsNotEntered', field: 'jeemainsNotEntered', cellStyle: { color: '#fb4700ff', cursor: 'pointer' },
    },
    { headerName: 'Valid', field: 'valid' },
    { headerName: 'Invalid', field: 'Invalid' },
    { headerName: 'NotVerified', field: 'notVerified' },
    { headerName: 'vit', field: 'vit' }
  ];


  defaultColDef = {
    // width: 150,
    flex: 1,
    cellStyle: {
      fontFamily: 'medium', textAlign: 'right'
    },
    headerStyle: { fontWeight: 'bold', background: '#0564B1', color: 'white' }
  };
  searchCriteria: string = '';
  campusId: any
  programName: any
  admNo: any
  mobileNo: any;
  rowData: any[];
  rowDataEntry: any[];
  remarks: any;
  gender: any;

  @ViewChild('searchCriteriaInput') searchCriteriaInput!: ElementRef<HTMLInputElement>;

  @ViewChild('pageContainer') pageContainer!: ElementRef;

  constructor(private jeemains: JeeSession1Service, private spinner: NgxSpinnerService, private dialog: NgDialogAnimationService, private dialogRef: MatDialog, private ngZone: NgZone, private cdRef: ChangeDetectorRef) {
    const today = new Date();
    this.currentDate = today.toLocaleDateString('en-GB'); // dd/MM/yyyy
  }
  ngOnInit(): void {
    console.log(this.searchCriteria);
    this.getCategoryDetails()
    this.getEnterdData();
    this.getEnteryData();
    (window as any).onEditClick = this.onEditClick.bind(this);
  }

  formatHeader(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

    // this.resetStudentData(); 
  }


  options: any[] = [];
  selectedAdmNo: string = '';
  selectedStudent: any = {};
  categoryList: any[] = [];
  selectedCategoryId: any = '';
  remarksDisabled: boolean = true;

  StudentName: any;
  parentName: any;
  cityName: any;
  campusName: any;
  examType: any;
  jeeMainsAppNo: any;
  studMobileNo: any;
  jeeMainsPassword: any;
  jeeMainsHtno: any;
  vitHtno: any;
  VitPassword: any
  studentEmail: any
  jeeFieldsDisabled: boolean = false;
   passwordStatus: any


  search(): void {
    if (this.searchCriteria && this.searchCriteria.length > 6) {
      this.jeemains.getAdmNo(this.searchCriteria).subscribe((res: any) => {
        this.options = res;
      });
    }
  }




  getStudentDetails(admNo: string): void {
    this.selectedAdmNo = admNo;
    this.jeemains.getStudentList(admNo).subscribe((res: any) => {
      this.selectedStudent = res;
      this.StudentName = this.selectedStudent?.studentName;
      this.jeeMainsAppNo = this.selectedStudent?.jeeMainsApplicationNo;
      this.disabledFields = !!this.jeeMainsAppNo;
      this.studMobileNo = this.selectedStudent?.mobileNo;
      this.disabledFields = !!this.mobileNo;
      this.jeeMainsPassword = this.selectedStudent?.jeeMainsPassword;
      this.disabledFields = !!this.jeeMainsPassword;
      this.jeeMainsHtno = this.selectedStudent?.jeeMainsHtno;
      this.disabledFields = !!this.jeeMainsHtno;
      this.studentEmail = this.selectedStudent?.studentEmail;
      this.disabledFields = !!this.studentEmail;
      this.categoryList = this.categoryList;
      this.remarksList = this.remarksList
      this.vitHtno = this.selectedStudent?.VitHtno;
      this.disabledFields = !!this.vitHtno;
      this.VitPassword = this.selectedStudent?.VitPassword;
      this.disabledFields = !!this.VitPassword;
      this.gender = this.selectedStudent.gender;
      this.parentName = this.selectedStudent.parentName;
      this.cityName = this.selectedStudent.cityName;
      this.campusName = this.selectedStudent.campusName;
      this.selectedCategoryId = this.selectedStudent?.categoryId ?? 0;
      this.examType=this.selectedStudent.examType;
      this.passwordStatus=this.selectedStudent.passwordStatus

      console.log('Student Details:', res);
      this.clearJeeCheck();
    });
  }

  optionSelected(option: any, event: any): void {
    if (event.isUserInput) {
      this.searchCriteria = option.admNo; // show admNo in input box
      this.getStudentDetails(option.admNo); // call API to get student details
    }
  }

  jeeMainsDisabled: boolean = false;
  isJeeNotApplied: boolean = false;


  getCategoryDetails(): void {
    this.jeemains.getCategoryList().subscribe((res: any[]) => {
      this.categoryList = res;
      console.log('Category List:', res);
    });
  }


 submitForm() {
  if (!this.searchCriteria) {
    if (!this.searchCriteriaInput.nativeElement.value) {
      alert('Please enter Admission Number');
      setTimeout(() => {
        this.searchCriteriaInput.nativeElement.focus();
      });
      return;
    }
  }

  if (!this.studentEmail) {
    if (!this.studentEmailInput.nativeElement.value) {
      alert('Please Enter Student Email');
      setTimeout(() => {
        this.studentEmailInput.nativeElement.focus();
      });
      return;
    }
  }

 if (!this.selectedCategoryId) {
  alert('Please select category');
  // Focus the mat-select component
  setTimeout(() => {
    this.selectedCategoryIdInput.nativeElement.focus();
  });
  return;
}


  if (!this.isJeeNotApplied) {
    // if (!this.examType) {
    //   if (!this.examTypeInput.nativeElement.value) {
    //     alert('Please select Exam Type');
    //     setTimeout(() => {
    //       this.examTypeInput.nativeElement.focus();
    //     });
    //     return;
    //   }
    // }

    if (!this.jeeMainsAppNo) {
      if (!this.jeeMainsAppNoInput.nativeElement.value) {
        alert('Please enter Jee Mains Application Number');
        setTimeout(() => {
          this.jeeMainsAppNoInput.nativeElement.focus();
        });
        return;
      }
    }

    if (this.jeeMainsAppNo.length < 12) {
      alert('JEE-MAINS Application Number must be 12 digit number');
      setTimeout(() => {
        this.jeeMainsAppNoInput.nativeElement.focus();
      });
      return;
    }

    if (!this.studMobileNo) {
      if (!this.studMobileNoInput.nativeElement.value) {
        alert('Please enter Mobile Number');
        setTimeout(() => {
          this.studMobileNoInput.nativeElement.focus();
        });
        return;
      }
    }

    if (this.studMobileNo.length < 10) {
      alert('Mobile Number must be 10 digit number');
      setTimeout(() => {
        this.studMobileNoInput.nativeElement.focus();
      });
      return;
    }

    if (!this.jeeMainsPassword) {
      if (!this.jeeMainsPasswordInput.nativeElement.value) {
        alert('Please enter Jee Mains Password');
        setTimeout(() => {
          this.jeeMainsPasswordInput.nativeElement.focus();
        });
        return;
      }
    }

    const jeeHtnoStr = this.jeeMainsHtno ? String(this.jeeMainsHtno).trim() : '';
    if (jeeHtnoStr && jeeHtnoStr.length < 8) {
      alert("JEE-MAINS Hall Ticket Number must be at least 8 digits");
      setTimeout(() => {
        this.jeeHtnoInput.nativeElement.focus();
      });
      return;
    }

    const vitHtnoStr = this.vitHtno ? String(this.vitHtno).trim() : '';
    if (vitHtnoStr && vitHtnoStr.length < 8) {
      alert('VIT Hall Ticket Number must be at least 8 digits');
      setTimeout(() => {
        this.vitHtnoInput.nativeElement.focus();
      });
      return;
    }


const vitPasswordStr = this.vitHtno ? String(this.VitPassword || '').trim() : '';

if (!vitPasswordStr) {
  setTimeout(() => {
    this.VitPasswordInput.nativeElement.focus();
  });
  return; 
}

  } 

  if (confirm("Do you want to save?")) {
    const studentData = {
      admNo: this.searchCriteria,
      studentEmail: this.studentEmail,
      examType: this.examType,
      jeeMainsApplicationNo: this.jeeMainsAppNo,
      jeeMainsPassword: this.jeeMainsPassword,
      jeeMainsHtno: this.jeeMainsHtno,
      vitHtno: this.vitHtno,
      vitPassword: this.VitPassword,
      mainsSession: 'JeeMainsSession1',
      mobileNo: this.studMobileNo,
      appliedStatus: '',
      categoryId: this.selectedCategoryId,
      remarks: this.remarks,
      gender: this.gender,
      StudentName: this.StudentName,
      parentName: this.parentName,
      cityName: this.cityName,
      campusName: this.campusName,
  
    };

    console.log('studentData', studentData);

    this.jeemains.createStudent(studentData).subscribe({
      next: (response) => {
        console.log('Success:', response);
        let resObj;
        try {
          resObj = typeof response === 'string' ? JSON.parse(response) : response;
        } catch (e) {
          resObj = response;
        }

        if (resObj.status === 'OK') {
          alert(resObj.message);
          this.clearForm();
          this.getEnterdData();
          this.getEnteryData();
        } else {
          alert(resObj.message);
        }
      },
      error: (error) => {
        console.error('Error:', error);
        alert('Error saving student.');
      }
    });
  } else {
    console.log("Save cancelled by user.");
  }
}

  // @ViewChild('searchCriteriaInput') searchCriteriaInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jeeHtnoInput') jeeHtnoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jeeMainsAppNoInput') jeeMainsAppNoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('studentEmailInput') studentEmailInput!: ElementRef<HTMLInputElement>;
  @ViewChild('selectedCategoryIdInput') selectedCategoryIdInput!: ElementRef<HTMLInputElement>;
  @ViewChild('examTypeInput') examTypeInput!: ElementRef<HTMLInputElement>;
  @ViewChild('studMobileNoInput') studMobileNoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jeeMainsPasswordInput') jeeMainsPasswordInput!: ElementRef<HTMLInputElement>;
  @ViewChild('vitHtnoInput') vitHtnoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('VitPasswordInput') VitPasswordInput!: ElementRef<HTMLInputElement>;


  @ViewChild('jeeCheck') jeeCheck!: ElementRef<HTMLInputElement>;
  clearForm() {
    this.searchCriteria = '';
    this.studentEmail = '';
    this.examType = '';
    this.jeeMainsAppNo = '';
    this.jeeMainsPassword = '';
    this.jeeMainsHtno = '';
    this.vitHtno = '';
    this.VitPassword = '';
    this.studMobileNo = '';
    this.selectedCategoryId = '0';
    this.remarks = '';
    this.jeeCheck.nativeElement.checked = false;
    this.isJeeNotApplied = false;
    this.StudentName = '';
    this.parentName = '';
    this.cityName = '';
    this.campusName = '';
    this.selectedStudent = {} as any;
  }

  clearJeeCheck() {
 this.jeeCheck.nativeElement.checked = false;
  }



clearJeeFields() {
  if (this.isJeeNotApplied) {
    //  Checkbox checked — clear and disable
    this.jeeMainsAppNo = '';
    this.studMobileNo = '';
    this.jeeMainsPassword = '';
    this.jeeFieldsDisabled = true;
  } else {
    //  Checkbox unchecked — enable fields again
    this.jeeFieldsDisabled = false;
    this.remarks = '';
  }
}



  getEnterdData(): void {
    this.jeemains.getEnteredDta().subscribe((data) => {
      console.log(data)
      this.rowData = data;
    });
  }
  getEnteryData(): void {
    this.jeemains.getEntereyDta().subscribe((data) => {
      console.log(data)
      this.rowDataEntry = data;
    });
  }

  onNumericInput(event: any, fieldName: 'studMobileNo' | 'jeeMainsAppNo' | 'vitHtno'): void {
    const input = event.target.value.replace(/[^0-9]/g, '');
    event.target.value = input;
    (this as any)[fieldName] = input;
  }
  onCellClicked(event: any) {
    if (event.colDef.field === 'jeemainsNotEntered') {
      this.getJeeMainsNotAppliedClick(event.data);  // send row data if needed
    }
  }


  getJeeMainsNotAppliedClick(data: any) {
  const dialogRef = this.dialog.open(JeeMainsNotAppliedComponent, {
    direction: 'ltr',
    height: '100%',
    width: '45%',
    data: data,
    position: { right: '0px', top: '0px' },
    animation: { to: 'left' }
  });

  dialogRef.afterClosed().pipe(take(1)).subscribe((result: any) => {
    if (result && result.admNo) {
      this.searchCriteria = result.admNo;
      this.getStudentDetails(result.admNo);

      // Wait until Angular finishes rendering new content
      this.ngZone.onStable.pipe(take(1)).subscribe(() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          if (this.searchCriteriaInput?.nativeElement) {
            const inputEl = this.searchCriteriaInput.nativeElement as HTMLInputElement;
            inputEl.focus();
            inputEl.select();
          }
        }, 200); // small delay ensures element is visible and focusable
      });
    }
  });

  this.isJeeNotApplied = false;
}

  currentDate: string;
  disabledFields: boolean = false;

  onInputField(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;

    // Disable if input is filled with bound data (length check or specific value match)
    if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsApplicationNo) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsApplicationNo) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.mobileNo) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsPassword) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.jeeMainsHtno) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.studentEmail) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.VitHtno) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

    if (inputValue != null && inputValue === this.selectedStudent?.VitPassword) {
      this.disabledFields = true;
    } else {
      this.disabledFields = false;
    }

  }

  remarksList: string[] = [
    'Under Age',
    'Long Absent',
    'Health Issue',
    'First Year Backlog',
    'Interested in EAMCET or other courses'
  ];

   
examTypes: string = 'ONLINE';

}
